import StickyTableWrap from '../common/StickyTableWrap';

export default StickyTableWrap;
